import { Layers } from "lucide-react"
import { useTranslation } from "react-i18next"

// The practice classroom's stand-in for the flashcard-capture surface (#945).
// In a real lesson this slot holds VocabularyStrip + WordPopover; in practice
// mode capture is DISABLED by decision (2026-09-28): people should see where
// the feature lives, but trying it must create nothing — so this is pure
// presentation, with no capture imports and no network calls.
export function PracticeCaptureNotice() {
  const { t } = useTranslation()
  return (
    <div className="flex items-start gap-2 px-3 py-2 border-b border-border bg-secondary/50 shrink-0">
      <Layers className="w-4 h-4 text-muted-foreground mt-0.5 shrink-0" />
      <div className="min-w-0">
        <p className="text-xs font-medium text-foreground">{t("liveSession.practice.captureNotice.title")}</p>
        <p className="text-xs text-muted-foreground">{t("liveSession.practice.captureNotice.body")}</p>
      </div>
    </div>
  )
}
